import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const actionTypes = {
    LOADER: "LOADER",
    BRANCH_LIST : "BRANCH_LIST",
    MEMBER_LIST: "MEMBER_LIST",
    CREDIT_LIST: "CREDIT_LIST",
    ROLE_LIST:"ROLE_LIST",
    ZONE_WISE_BRANCH_LIST: "ZONE_WISE_BRANCH_LIST",
    ALL_BRANCH_LIST: "ALL_BRANCH_LIST",
};

export const VfsuklpLoader = () => {
    return {
        type: actionTypes.LOADER,
        vfsuklploader: true,
    };
};

//  get all branch list
export const VfsuklpBranchlist = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    // const master_CorpoId = JSON.parse(authToken)?.data?.corporateID || process.env.REACT_APP_CORPORATE_ID;

    return async (dispatch) => {
        await axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/uk/branch-list`, {
                params: { ...query },
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.BRANCH_LIST,
                    BranchList: response.data,
                });
                dispatch({ type: actionTypes.LOADER, vfsuklploader: false})
            })
            .catch((err) => {
                // console.log(err);
                dispatch({ type: actionTypes.LOADER, vfsuklploader: false})
            });
    };
};

//  get all member list
export const GetVfsuklpMemberList = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;

    return async (dispatch) => {
        await axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/uk/member-list`, {
                params: { ...query },
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.MEMBER_LIST,
                    MemberList: response.data,
                });
                dispatch({ type: actionTypes.LOADER, vfsuklploader: false})
            })
            .catch((err) => {
                // console.log(err);
                dispatch({ type: actionTypes.LOADER, vfsuklploader: false})
            });
    };
};

//  get all credit list
export const GetVfsuklpCreditList = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;

    return async (dispatch) => {
        await axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/uk/credit-list`, {
                params: { ...query },
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.CREDIT_LIST,
                    CreditList: response.data,
                });
                dispatch({ type: actionTypes.LOADER, vfsuklploader: false})
            })
            .catch((err) => {
                // console.log(err);
                dispatch({ type: actionTypes.LOADER, vfsuklploader: false})
            });
    };
};

// get role list
export const GetVfsuklpRoleList = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;

    return async (dispatch) => {
        await axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/uk/accountant-list`, {
                params: { ...query },
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.ROLE_LIST,
                    RoleList: response.data,
                });
                dispatch({ type: actionTypes.LOADER, vfsuklploader: false})
            })
            .catch((err) => {
                // console.log(err);
                dispatch({ type: actionTypes.LOADER, vfsuklploader: false})
            });
    };
};

// create role 
export const VfsuklpRoleCreate = (data,setCorporatemodel) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;

    return async (dispatch) => {
        await axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/uk/role/create`, data,{
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                dispatch(GetVfsuklpRoleList());
                toast.success(response.data.message)
                setCorporatemodel(false)
            })
            .catch((err) => {
                // console.log(err);
                toast.error(err.response.data.error)
            });
    };
};

// update role status
export const UpdateVfsuklpRoleStatus = (data) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;

    return async (dispatch) => {
        await axios
            .patch(`${process.env.REACT_APP_API_BASE_URL}/uk/role/update-status`, data, {
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                toast.success(response.data.message)
                dispatch(GetVfsuklpRoleList());
            })
            .catch((err) => {
                // console.log(err);
            });
    };
};

// update role
export const UpdateVfsuklpRole = (data, setEditModalOpen) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;

    
    return async (dispatch) => {
        await axios
            .patch(`${process.env.REACT_APP_API_BASE_URL}/uk/role/update-zone`, data, {
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                toast.success(response.data.message)
                setEditModalOpen(false)
                dispatch(GetVfsuklpRoleList());
            })
            .catch((err) => {
                // console.log(err);
            });
    };
};

// get branch zone list
export const GetVfsuklpZoneWiseBranchList = (data) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;

    
    return async (dispatch) => {
        await axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/uk/branch`,{
                params: { ...data },
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.ZONE_WISE_BRANCH_LIST,
                    ZoneWiseBranchList: response.data,
                });
            })
            .catch((err) => {
                // console.log(err);
            });
    };
};

// refund export
export const ExportVfsuklpCreditNoteData = (query) => {

    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/uk/credit-list/export`,
        {
          params: { ...query },
          headers: {
            "X-access-token": token,
          },
        })
        .then((response) => {
          toast.success(response.data.message, {
            theme: "colored",
            autoClose: 2000,
          });
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
        })
        .catch((err) => {
          toast.error(err.response.data.error, {
            theme: "colored",
            autoClose: 2000,
          });
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
        });
    };
  };


//   get all branch list
export const GetVfsuklpAllBranchList = () => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    return async (dispatch) => {
        await axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/ukk/branch-list`, {
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.ALL_BRANCH_LIST,
                    AllBranchList: response.data,
                });
            })
            .catch((err) => {
                // console.log(err);
            });
    };
};

// send email to team member
export const SendEmailToTeamMember = (data) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    return async (dispatch) => {
        await axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/uk/team/send-credintial/${data}`,data, {
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                toast.success(response.data.message)
            })
            .catch((err) => {
                console.log(err);
                toast.error(err.response.data.message)

            });
    };
};
